<div class="custombox-layout" #layoutCustomBox>
  <section class="container-fluid custom-box">
    @defer (when !isLoadingContent()) {

    <!-- Breadcrumbs: -->
    @if (!isLimitedUser() && !isMobile()) {
    <div class="row">
      <div class="col align-self-start justify-content-start">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            @if (!isCustomBoxSignupFlow()) {
            <li class="breadcrumb-item">
              <a>
                <span class="material-symbols-outlined" [routerLink]="'/shop'">home</span>
              </a>
            </li>
            <li class="breadcrumb-item  breadcrum-text-item" (click)="gotoCategory(product()?.category?.name)">
              {{ product()?.category?.name }}
            </li>
            } @else {
            <li class="breadcrumb-item  breadcrum-text-item" [routerLink]="'/signup'">
              Go Back
            </li>
            }
            <li class="breadcrumb-item active" aria-current="page">
              <span class="fw-bold breadcrum-text-item">
                {{ product()?.name }}
              </span>
            </li>
          </ol>
        </nav>
      </div>
    </div>
    }

    @if(isMobile()) {
    <ng-container *ngTemplateOutlet="myBoxMainInfo"></ng-container>
    }

    @if (isMobile()) {
    <div class="row">
      <div class="col-md-12">
        <ng-container *ngTemplateOutlet="mainTabsComponent; context: { $implicit: mainTabs() }"></ng-container>
      </div>
    </div>
    } @else {
    <div class="row g-5">

      <!-- My Box -->
      <section [class.col-md-5]="!isSubscriptionSkipped()" [class.col-md-12]="isSubscriptionSkipped()">
        <ng-container *ngTemplateOutlet="myBoxComponent; context: { template: myBoxMainInfo }"></ng-container>
      </section>

      @if (!isSubscriptionSkipped()) {
      <!-- Add-ons -->
      <section class="col-md-7">
        <ng-container *ngTemplateOutlet="mainTabsComponent; context: { $implicit: mainTabs() }"></ng-container>
      </section>
      }

    </div>
    }

    } @placeholder (minimum 2s) {
    <div class="loading z-n1">
      <div class="loader">
        @for (item of [0,0,0,0,0]; track $index) {
        <div class="bg-secondary"></div>
        }
      </div>
      <h1>
        Just a moment! We're getting your box all set up for you.
      </h1>
    </div>
    }
  </section>

  <!-- Mobile Save Button -->
  @if(isMobile() && isAbleToDiscardChanges()) {
  <div #customBoxActionWrap class="custombox-action-wrap animated fadeInUp" id="customBoxActionWrap">
    <ng-container *ngTemplateOutlet="saveButtonTemplate; context: {allowDiscard: true}"></ng-container>
  </div>
  }

  <!-- TEMPLATES: -->

  <ng-template #mainTabsComponent let-tabs>
    <div class="custom-box-addons">

      @if (!isSubscriptionSkipped()) {
      <!-- Tabs Container -->
      <div class="row" [class.tabs-container]="isMobile()"
        [class.no-padding-bottom]="isMobile() && !youBoxTabSelected()"
        [class.no-top]="!boxMaximumOrder() && !showLimitedMinimumOrder()">
        <!-- Main Tabs -->
        <div class="row m-0">
          <div class="col-12 custom-box-addons__tabs">
            @if (isMobile()) {
            <div class="tab" (click)="viewMyBox()" [class.selected]="youBoxTabSelected()">
              Your Box
            </div>
            }
            @for (item of tabs; track $index) {
            @if (item.show) {
            <div class="tab" [class.selected]="item.active" (click)="changeTab(item)">
              @let displayName = isMobile() ? item.mobileName : item.name;
              {{displayName}}
            </div>
            }
            }
          </div>
        </div>

        <!-- Categories -->
        @if (categoriesInView().length) {
        <div class="custom-box-addons__categories">
          <div class="arrow" (click)="mainCategoriesScroll(true)">
            <span class="material-symbols-outlined">
              chevron_left
            </span>
          </div>
          <div class="main" id="mainCategories">
            @for (item of categoriesInView(); track item.name) {
            <span class="category" [class.selected]="item.selected" (click)="changeCategory(item)">
              {{item.name}}
            </span>
            }
          </div>
          <div class="arrow" (click)="mainCategoriesScroll()">
            <span class="material-symbols-outlined">
              chevron_right
            </span>
          </div>
        </div>
        }
      </div>

      <!-- Products -->
      @if (addOnsInView().size) {
      <div class="row" [class.add-ons-container]="!isMobile()">
        <div class="col-12">
          @for (item of addOnsInView().keys(); track item) {
          @if (item) {
          <h4 class="h4-bold my-3">
            {{item}}
          </h4>
          }
          <div class="row">
            @for (addableProduct of addOnsInView().get(item)?.values(); track addableProduct?.id) {
            <div class="col-sm-6 col-md-6 col-lg-4 animated fadeIn p-12">
              <app-addable-product-card [product]="addableProduct" [isLimitedUser]="isLimitedUser()"
                [isLockedBundle]="product().bundle.isLocked || false" [isFixedBundle]="product().bundle.isFixed"
                (addItem)="onAddItem($event)">
              </app-addable-product-card>
            </div>
            }
          </div>
          }
        </div>
      </div>
      }

      }

      <!-- Your Box -->
      @if (youBoxTabSelected()) {
      <div class="py-4">
        <ng-container *ngTemplateOutlet="myBoxComponent;"></ng-container>
      </div>
      }

    </div>
  </ng-template>

  <ng-template #myBoxComponent let-template="template">
    <div [class.custom-box-main]="!isSubscriptionSkipped()" [class.custom-box-main__desktop]="!isMobile()">

      @if(!isMobile()) {
      <ng-container *ngTemplateOutlet="template"></ng-container>
      }

      <!-- Products -->
      @if (items().size && !isSubscriptionSkipped()) {
      <div class="row">
        @for (bundleItem of items().values(); track bundleItem.id) {
        <div class="col-sm-6 col-md-6 col-lg-6 animated fadeIn p-12">
          <app-addable-product-card [removable]="true" [product]="bundleItem" [isLimitedUser]="isLimitedUser()"
            [isLockedBundle]="product().bundle.isLocked || false" [isFixedBundle]="product().bundle.isFixed"
            (removeItem)="onRemoveItem($event)" (changeQuantity)="onChangeQuantity($event)">
          </app-addable-product-card>
        </div>
        }
      </div>
      }

    </div>
  </ng-template>

  <!-- Bundle main info: -->
  <ng-template #myBoxMainInfo>

    <div class="main-info-container">
      <app-product-main-info [product]="product()" [subTotalAmount]="subTotalAmount()"
        [frequency]="selectedFrequency()?.value?.name" [deliveryDate]="selectedStartDate()" [whatsInsideItems]="items()"
        [productSubscriptionInfo]="productSubscriptionInfo()"
        [isSubscriptionSkipped]="isSubscriptionSkipped()"></app-product-main-info>

    </div>

    <div [ngClass]="{'row': !isMobile(), 'cta-container-desktop': !isMobile(), 'cta-container': isMobile()}">
      @if(!isSubscriptionSkipped()) {
      <div class="row-field animated fadeIn" #ctaContainer>
        @if (product()?.bundle && product()?.bundle?.items?.length) {
        <a class="row-field__action link-color" (click)="openModalWhatsInside()">
          What's Inside
          <i class="fas fa-eye"></i>
        </a>
        }
        <a class="row-field__action link-color" (click)="openModalSkipProduct()">Skip</a>
      </div>

      <hr class="mb-1">

      }

    </div>
    @if (!isSubscriptionSkipped()) {

    <!-- Desktop Save Button -->
    @if (!isMobile() && isAbleToDiscardChanges()) {
    <div class="row button-save-container">
      <div class="col-12">
        <ng-container *ngTemplateOutlet="saveButtonTemplate; context: {allowDiscard: true}"></ng-container>
      </div>
    </div>
    }

    <!-- Maximum box items -->
    @if (boxMaximumOrder()) {
    <div class="row py-2" [class.progress-bar-sticky-top]="isMobile()"
      [class.maximum-container]="!(!isMobile() && isAbleToDiscardChanges())"
      [class.maximum-container-with-button]="!isMobile() && isAbleToDiscardChanges()">
      <div class="col-12">
        <div class="custom-box-main__maximum_indicator">
          <h5 class="title">
            Your Box Maximum ({{boxMaximumOrder()}} items)
          </h5>
          <section class="d-flex align-items-center gap-2 justify-content-around order-scale">
            <mat-progress-bar mode="determinate" [value]="boxPercentOfLimit()"></mat-progress-bar>
            <small class="text-nowrap item">
              {{ addedItemsQuantity() }} items
            </small>
          </section>
        </div>
      </div>
    </div>
    }
    }
  </ng-template>


  <!-- Save Button Template: -->
  <ng-template #saveButtonTemplate let-allowDiscard="allowDiscard">
    <div class="row">
      <section class="animated fadeIn" [class.col-12]="!allowDiscard"
        [class.col-8]="allowDiscard && isAbleToDiscardChanges()">
        <button type="button" class="btn btn-secondary w-100" (click)="openModalSaveBundle()"
          [disabled]="shouldDisableSaveButton()">
          Done Customizing
        </button>
      </section>
      @if (isAbleToDiscardChanges() && allowDiscard) {
      <section class="col-4 animated fadeIn">
        <button type="button" class="btn btn-outline-primary w-100 btn-discard" (click)="undoChanges()"
          [ngbTooltip]="'Discard Changes'">
          <span class="material-symbols-outlined">
            undo
          </span>
        </button>
      </section>
      }
    </div>
  </ng-template>

  <!-- @if (!isLoadingContent() && isMobile()) {
  <div class="section-sticky-container" [class.subtabs-active]="!youBoxTabSelected()"></div>
  } -->
</div>